/* eslint-disable complexity */
/* eslint-disable no-console */
// 左侧消息条

import React, { useCallback, useEffect, useMemo, useState, useContext, useRef } from "react";
import { connect } from "dva";
import {
  ChatMessage,
  Employee,
  Group,
  MessageStatus,
  SessionProps,
  Session as SessionType
} from "@/types/chat";
import ChatState from "@/types/chat/State";
import { sessionDateFormat } from "@/utils/date";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { Dropdown, Menu, Divider } from "antd";
import { useTranslation, WithTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import { FocusSDK as focusSDK, isFocusEnv } from "@/utils";
import {
  isEqualEmployee,
  uidToEmployee,
  mySendMessage,
  isEqualUid,
  employeeToUid,
  computeAITimestamp,
  isTopSession,
  isShieldSession,
  isCrossPlatformGroupSession
} from "@/utils/chat/message";
import { HeadShowType } from "@/types/chat/enum";
import { GroupExternalTagBySession, SessionTag, singleSessionDeptName } from "@/components/Tags";
import Context from "@/components/chat/context";
import Bus from "@/utils/bus";
import {
  useGetMessageDesc,
  useHandleContextMenuClick,
  useHandleSessionClick
} from "@/components/chat/Session/common";
import GroupRoster from "@jd/jdee.im.sdk/lib/es/model/Roster";
import { isAINoticeSession, isOrgChatSession, isUnnecessarySession } from "@/utils/chat/session";
import { useHistory } from "react-router-dom";
// import OpenAnnounceInfo from "../../../components/Projects/components/AnnounceTab/announceInfo";
import OpenAnnounceInfo from "../../../../../../components/Projects/components/AnnounceTab/announceInfo";
import { findAlertAnnouncement } from "../../../../../Projects/api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import colors from "@/components/styles/colors";
import { AI_NOTICE_EXCLUDE_PINS } from "@/contant/chat";
import { usePrevious, userEscapeString } from "@/utils/chat/index";
import { analysisLog } from "@/utils/logAnalytics";
import ImService from "@/server/ImService";
import { tagsNode } from "@/components/AddressBook/common";
import classNames from 'classnames';
import styles from "./index.module.less";
import EllipsisTooltip from "./EllipsisTooltip";
import "./index.less";
// import CustomMenu from "@/baseComponents/CustomMenu";
import { CustomMenu } from "@jd/focus-desktop-comps";
interface SessionCompProps {
  // 会话对象
  session: SessionProps;
  // 群组会话消息条数
  pieces?: string;
  // 是否有@
  cue?: boolean;

  last: boolean;
  setCallBack?: () => void;
  history: any;
  onClick?: () => void;
  withoutContextMenu?: boolean;
  withoutUnreadTips?: boolean;
  withoutTimeStamp?: boolean;
  withoutBorder?: boolean;
  withoutClick?: boolean;
  right?: React.ReactNode;
  descTextCls?: string;
  style?: React.CSSProperties;
  readMsgCustom: string;
  customAppList: SessionType[];
  topUpModeCustom: string;
}

interface DvaDispatchProps {
  launchSingleSession: Function;
  initSelectedSession: Function;
  launchGroupSession: Function;
  launchNoticeSession: Function;
  launchOrgNoticeSession: Function;
  updateSelectedSession: Function;
  clearSessionMessage: Function;
  changeGroupAdmin: Function;
  changeSelectMore: Function;
  updateMessages: Function;
  setShowTagList: Function;
}

type IProps = Readonly<SessionCompProps & ChatState & DvaDispatchProps & WithTranslation>;

// eslint-disable-next-line complexity
function Session(props: IProps) {
  const [session, setSession] = useState<SessionProps | null>(null);
  const {
    session: sessionProps,
    selectedSession,
    launchGroupSession,
    launchSingleSession,
    initSelectedSession,
    setShowTagList,
    launchNoticeSession,
    launchOrgNoticeSession,
    setCallBack,
    sessionStatusMap,
    updateSelectedSession,
    clearSessionMessage,
    administrator,
    ordinary,
    changeGroupAdmin,
    onClick,
    withoutContextMenu,
    withoutUnreadTips,
    withoutTimeStamp,
    withoutClick,
    right,
    descTextCls,
    withoutBorder,
    changeSelectMore,
    updateMessages,
    aiNoticeSessionList,
    allSessionList,
    style,
    customAppList,
    readMsgCustom,
    topUpModeCustom
  } = props;
  
  const { t } = useTranslation("chat");
  const { authInfo, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const basename = appRuntimeEnv?.webConfig?.routeBase || "";
  const projectType = `project${
    ["mebj", "jgswy", "mebjJZB"].includes(appRuntimeEnv.runtimeConfig.key)
      ? "_" + appRuntimeEnv.runtimeConfig.key
      : ""
  }`;
  const t1 = useTranslation(projectType).t;
  const history = useHistory();

  const { currentEmployee, closeSetting } = React.useContext(Context);


  // const [visible, setVisible] = useState<boolean>(true);
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [isFoucsMsg, setIsFocusMsg] = useState<boolean>(false);

  useEffect(() => {
    // 更新session
    setSession(sessionProps);
  }, [sessionProps]);

  useEffect(() => {
    // 更新session
    if (isAINoticeSession(sessionProps)) {
      let unreadCount = 0;
      aiNoticeSessionList.forEach((item) => {
        if (item?.settings?.shield !== 1) {
          unreadCount += item.unreadCount || 0;
        }
      });
      setUnreadCount(unreadCount || 0);
    } else {
      // 设置未读数
      setUnreadCount(sessionProps.unreadCount || 0);
    }
    // 不显示不必要的会话
    // if (isUnnecessarySession(sessionProps)) {
    //     setVisible(false);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionProps, aiNoticeSessionList]);

  // 更新会话未读数量
  useEffect(() => {
    // tj: 处理unreadCount为0不更新, 点击闪动
    const info: any = session?.info || {};
    if (selectedSession?.sessionId !== session?.sessionId) {
      // 当前session不是ai助手的内置会话
      if (session?.isNotice && !AI_NOTICE_EXCLUDE_PINS.includes(info.userId)) {
        // 当前选中的session是否是ai助手
        if (selectedSession.isNotice && isAINoticeSession(selectedSession)) {
          setUnreadCount(0);
        } else {
          let unreadCount = 0;
          aiNoticeSessionList.forEach((item) => {
            if (item?.settings?.shield !== 1) {
              unreadCount += item.unreadCount || 0;
            }
          });
          setUnreadCount(unreadCount || 0);
        }
      } else {
        setUnreadCount(session?.unreadCount || 0);
      }
    } else if (
      isAINoticeSession(selectedSession) &&
      !AI_NOTICE_EXCLUDE_PINS.includes(info.userId) &&
      session?.isNotice
    ) {
      setUnreadCount(0);
    }
  }, [session, aiNoticeSessionList, selectedSession]);

  const updateGroupRoster = useCallback(async () => {
    if (administrator.length === 0) {
      return;
    }
    const { owner } = sessionProps.info as Group;
    const newAdmin = uidToEmployee(owner) as Employee;
    const oldAdmin = administrator[0].info;
    // 新旧管理员不一样
    if (oldAdmin && newAdmin && !isEqualEmployee(newAdmin, oldAdmin)) {
      // 进行替换管理员操作
      const newAdminRosterIndex = ordinary.findIndex((item: any) =>
        isEqualEmployee(newAdmin, item.info)
      );
      const newAdminRoster = ordinary[newAdminRosterIndex];
      // 替换
      ordinary[newAdminRosterIndex] = {
        ...administrator[0],
        identity: "ordinary"
      };
      administrator[0] = { ...newAdminRoster, identity: "administrator" };
      await changeGroupAdmin({
        ordinary: [...(ordinary || [])],
        administrator: [...(administrator || [])]
      });
    }
  }, [administrator, changeGroupAdmin, ordinary, sessionProps.info]);

  const updateSession = useCallback(
    async (session: SessionProps) => {
      setSession(session);
      setUnreadCount(session?.unreadCount || 0);
      if (session.sessionId === selectedSession.sessionId) {
        if (isAINoticeSession(selectedSession)) {
          aiNoticeSessionList.forEach((item) => {
            item.unreadCount = 0;
          });
        }
        setUnreadCount(0);

        if (session.isGroup) {
          const group = session.info as Group;
          if (group.rosterSize > 0) {
            await updateGroupRoster();
          }
        }
        // await updateSelectedSession({ selectedSession: session });
      }
    },

    [selectedSession, updateGroupRoster, aiNoticeSessionList] // eslint-disable-line
  );

  useEffect(() => {
    Bus.on(`chat:session-update:${sessionProps.sessionId}`, updateSession);
    return () => {
      Bus.off(`chat:session-update:${sessionProps.sessionId}`, updateSession);
    };
  }, []); //eslint-disable-line

  const sessionRemoveListener = useCallback(async () => {
    console.log("getAllSessionList===topUpSessionRemoveListener");
    // 移除会话列表中的会话时不影响置顶会话
    // setSession(null);
    // history.push(`/messages`);会导致页面闪烁，暂时注释
    // if (sessionProps.sessionId === selectedSession.sessionId) {
    //   history.push(`/messages`);
    // }
    // focusSDK.sendIpcMessage("flashSessionForceClear", { sessionId: sessionProps.sessionId });
  }, [history, selectedSession.sessionId, sessionProps.sessionId]);

  useEffect(() => {
    Bus.on(`chat:session-remove:${sessionProps.sessionId}`, sessionRemoveListener);
    return () => {
      Bus.off(`chat:session-remove:${sessionProps.sessionId}`, sessionRemoveListener);
    };
  }, []); //eslint-disable-line

  const isTopSessionButDeleted = (session: SessionProps | null) => {  
    return session?.del === 1;
  }
  // 点击选中某一条会话
  // @ts-ignore
  const handleClick = useHandleSessionClick({
    selectedSession,
    session,
    launchSingleSession,
    initSelectedSession,
    launchNoticeSession,
    launchOrgNoticeSession,
    launchGroupSession,
    setCallBack,
    changeSelectMore,
    updateMessages,
    history,
    closeSetting,
    basename,
    readMsgCustom,
    shouldCreate: isTopSessionButDeleted(session) // 点击的置顶会话在列表中不存在是，shouldCreate设置为true，同时del设置为0
  });
  const getAnnouncement = useCallback(() => {
    if (!session) {
      return;
    }
    const sessionInfo = session.info as any;
    if (session.isGroup) {
      const sessionId = sessionInfo.gid || sessionInfo.businessId;
      if (sessionId) {
        // 组公告弹窗
        findAlertAnnouncement(sessionId).then((res) => {
          if (!res?.announcementDetailInfo) return;
          const announcementDetailInfo = res.announcementDetailInfo;

          // 当前登录人发的公告 不弹窗
          if (
            announcementDetailInfo.senderUserId === authInfo.userId &&
            (announcementDetailInfo.senderTeamId === authInfo.selectedTeamId ||
              announcementDetailInfo.senderTeamId === authInfo.teamUserInfo?.teamId) &&
            announcementDetailInfo.senderUserAppId === authInfo.ddAppId
          ) {
            return;
          }
          const el = document.getElementById("pm-announceinfo-wrap");
          if (el) {
            return;
          }
          OpenAnnounceInfo({
            content: announcementDetailInfo?.content || "",
            pictures:
              typeof announcementDetailInfo.attachmentUrl === "string"
                ? JSON.parse(announcementDetailInfo.attachmentUrl) || []
                : announcementDetailInfo.attachmentUrl,
            projectId: sessionId || announcementDetailInfo?.announcementTypeId,
            announceId: announcementDetailInfo?.announcementId || "",
            t: t1
          });
        });
      } else {
        console.warn("session ===> findAlertAnnouncement", session);
      }
    }
  }, [authInfo, session, t1]);

  const getMessageDesc = useGetMessageDesc({
    sessionStatusMap,
    currentEmployee,
    selectedSession,
    session: sessionProps, // 王振朋修改
    allSessionList,
    customAppList
  });


  const handleContextMenuClick = useHandleContextMenuClick({
    sessionId: sessionProps.sessionId,
    selectedSessionId: selectedSession.sessionId,
    t,
    clearSessionMessage,
    history,
    msg: session?.lastMsg as ChatMessage,
    session
  });
  
  useEffect(() => {
    if (!session || !unreadCount) {
      setIsFocusMsg(false);
      return;
    }
    const s = session as any;
    if (s.followCount > 0) {
      setIsFocusMsg(true);
    } else {
      if (s.isGroup && isShieldSession(s) && s.attentionCount > 0) {
        setIsFocusMsg(true);
      } else {
        setIsFocusMsg(false);
      }
    }
  }, [session, unreadCount]); // eslint-disable-line

  const aiSessionTimestamp = useMemo(() => {
    return computeAITimestamp(aiNoticeSessionList);
  }, [aiNoticeSessionList]);

  const sessionTimestamp = useMemo(() => {
    if (isAINoticeSession(session || ({} as any))) {
      return sessionDateFormat(aiSessionTimestamp);
    } else {
      return sessionDateFormat(session?.lastMsg?.timestamp || session?.timestamp || 0);
    }
  }, [session, aiSessionTimestamp]);

  const hoverCls = useMemo(() => {
    return withoutClick ? "withoutHover" : "";
  }, [withoutClick]);

  const aiShieldNoticeNum = useMemo(() => {
    if (!session || !isAINoticeSession(session)) {
      return 0;
    }
    let unreadCount = 0;
    let shieldCount = 0;
    aiNoticeSessionList.forEach((item) => {
      if (item?.settings?.shield !== 1) {
        unreadCount += item.unreadCount || 0;
      } else {
        shieldCount += item.unreadCount || 0;
      }
    });
    if (unreadCount > 0) {
      return 0;
    } else {
      // 免打扰消息数量
      return shieldCount;
    }
  }, [aiNoticeSessionList, session]);

  // AI助手当只有免打扰通知显示免打扰标记
  const isAIShowShieldState = useMemo(() => {
    if (!session || !isAINoticeSession(session)) {
      return false;
    }
    return aiShieldNoticeNum > 0;
  }, [aiShieldNoticeNum, session]);

  const sessionClass = useMemo(() => {
    return [
      "session-container",
      (isShieldSession(session || ({} as any)) || isAIShowShieldState)
        ? "session-container_shield"
        : "",
      isTopSession(session || ({} as any)) ? "session-container_top" : "",
      hoverCls,
      session?.sessionId === selectedSession.sessionId ? "selected" : ""
    ].join(" ");
  }, [hoverCls, selectedSession.sessionId, session, isAIShowShieldState]);

  const handleSessionClick = useCallback(() => {
    if (onClick) {
      onClick();
      return;
    }
    // console.log("handleSessionClick", session, allSessionList);
    handleClick();
    if (session?.sessionId !== selectedSession.sessionId) {
      setShowTagList([]);
    }
    getAnnouncement();
  }, [
    session,
    withoutClick,
    onClick,
    handleClick,
    selectedSession.sessionId,
    getAnnouncement,
    setShowTagList
  ]);


  const sessionName = useMemo(() => {
    return userEscapeString(session?.info?.name || "");
  }, [session]);

  const onMouseDown = (e: React.MouseEvent) => {
    if( e.button === 2 ) {
      return; // 右键不处理
    }
    startPos.x = e.clientX;
    startPos.y = e.clientY;
    console.log("Mouse down at:", startPos.x, startPos.y);
  };

const onMouseUp = (e: React.MouseEvent) => {
  const endX = e.clientX;
  const endY = e.clientY;

  // 计算位移
  const deltaX = endX - startPos.x;
  const deltaY = endY - startPos.y;
  const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

  console.log(`位移: X方向 ${deltaX}px, Y方向 ${deltaY}px, 总距离 ${distance.toFixed(2)}px`);

  // 判断是点击还是拖拽
  if (distance < 5) { // 5px阈值
    console.log("这是点击操作");
    handleSessionClick();

  } else {
    console.log("这是拖拽操作");
  }
};

  const memoComp = useMemo(() => {
    const count =
      session && isAINoticeSession(session)
        ? unreadCount || aiShieldNoticeNum
        : session?.unreadCount;
    const employeeExt = (session?.info as any)?.employeeExt || {};
    const remark = employeeExt?.remark;
    return (
      <div onMouseDown={onMouseDown} onMouseUp={onMouseUp} className={classNames(styles["chat-left-avatar"], {
        [styles["active"]]: session?.sessionId === selectedSession.sessionId
        // "chat-left-avatar-shield": (isShieldSession(session || ({} as any)) || isAIShowShieldState) && !(session?.mentions && Object.values(session?.mentions).length > 0)
      })} key={session?.id}>
        <div className={styles["chat-left-avatar-img"]}>
          <HeadPortrait
            member={session}
            width="36px"
            height="36px"
            fontSize="13px"
            imgUrl={session?.info?.avatar || ""}
            name={session?.name || session?.info?.name || ""}
            type={session?.sessionType}
            numPieces={withoutUnreadTips ? 0 : count || 0}
            mentions={session?.mentions}
            shield={(isShieldSession(session || ({} as any)) || isAIShowShieldState) && !(session?.mentions && Object.values(session?.mentions).length > 0)}
          />
        </div>
        <EllipsisTooltip
          placement="bottom"
          title={`${sessionName}${remark ? `(${remark})` : ""
            }`}
          className={styles["chat-left-avatar-text"]}/>
        {session?.isSecret && (
          <div className={styles["top-session-secret"]}>
            <IconFont
              style={{ color: "#F96137" }}
              type="iconic_app_im_burnafterreading_facet"
            />
          </div>
        )}
      </div>
    )
  }, [
    session,
    unreadCount,
    sessionClass,
    handleSessionClick,
    withoutUnreadTips,
    selectedSession.sessionId,
    aiShieldNoticeNum
  ]);

  // 鼠标右键展示内容
  const renderContextMenu = () => {
    if (!session) {
      return <div />;
    }
    const isDis = session.isGroup && (session.info as any).status === 0;
    const settings = session.settings || {};
    // 基本菜单项
    const menuItems = [
      {
        key: 'top',
        label: t("session.menus.top2"),
        icon: <IconFont type="icona-stylezhiding" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True",
        hidden: (settings.top || 0) > 0
      },
      {
        key: 'untop',
        label: t("session.menus.untop2"),
        icon: <IconFont type="icona-stylequxiaozhiding" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_False",
        hidden: (settings.top || 0) === 0
      },
      {
        key: 'unshield',
        label: t("session.menus.shield2"),
        icon: <IconFont type="icona-styleyunxuxiaoxitongzhi" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreRemind_True",
        hidden: !isAINoticeSession(session) && (settings.shield || 0) === 0
      },
      {
        key: 'shield',
        label: t("session.menus.unshield2"),
        icon: <IconFont type="icona-stylexiaoximiandarao" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreRemind_False",
        hidden: !isAINoticeSession(session) && (settings.shield || 0) > 0
      },
      {
        key: '',
        label: "divider",
        isDivider: true
      },
      {
        key: 'empty',
        label: t("session.menus.empty"),
        icon: <IconFont type="iconquanjushanchu" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete"
      },
      {
        key: '',
        label: "divider",
        isDivider: true,
        hidden: session.isNotice || session.isSecret || !isFocusEnv() || isOrgChatSession(session)
      },
      {
        key: 'new',
        label: t("session.menus.open_new_window"),
        icon: <IconFont type="icona-styledulichuangkou" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_frame_1705031698942|1",
        hidden: session.isNotice || session.isSecret || !isFocusEnv() || isOrgChatSession(session),
        disabled: isDis
      }
    ];

    return (
      <CustomMenu onClick={handleContextMenuClick} items={menuItems} />
      // <Menu style={{padding: "4px"}} onClick={handleContextMenuClick}>
      //   {(settings.top || 0) === 0 && (
      //     <Menu.Item
      //       key="top"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True"
      //     >
      //       <IconFont type="icona-stylezhiding" />
      //       {t("session.menus.top2")}
      //     </Menu.Item>
      //   )}
      //   {(settings.top || 0) > 0 && (
      //     <Menu.Item
      //       key="untop"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_False"
      //     >
      //       <IconFont type="icona-stylequxiaozhiding" />
      //       {t("session.menus.untop2")}
      //     </Menu.Item>
      //   )}
      //   {!isAINoticeSession(session) && (settings.shield || 0) > 0 && (
      //     <Menu.Item
      //       key="unshield"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreRemind_True"
      //     >
      //       <IconFont type="icona-styleyunxuxiaoxitongzhi" />
      //       {t("session.menus.shield2")}
      //     </Menu.Item>
      //   )}
      //   {!isAINoticeSession(session) && (settings.shield || 0) === 0 && (
      //     <Menu.Item
      //       key="shield"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreRemind_False"
      //     >
      //       <IconFont type="icona-stylexiaoximiandarao" />
      //       {t("session.menus.unshield2")}
      //     </Menu.Item>
      //   )}
      //   <Divider style={{margin: "0px", color: "#E6E6E6"}} />
      //   <Menu.Item
      //     key="empty"
      //     onClick={maskHide}
      //     clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete"
      //   >
      //     <IconFont type="iconquanjushanchu" />
      //     {t("session.menus.empty")}
      //   </Menu.Item>
      //   {!session.isNotice && !session.isSecret && isFocusEnv() && !isOrgChatSession(session) && <Divider style={{margin: "0px", color: "#E6E6E6"}} />}
      //   {!session.isNotice && !session.isSecret && isFocusEnv() && !isOrgChatSession(session) && (
      //     <Menu.Item
      //       key="new"
      //       onClick={maskHide}
      //       disabled={isDis}
      //       style={{ opacity: `${isDis ? 0.5 : 1}` }}
      //       clstag="pageclick|keycount|Xtbg_frame_1705031698942|1"
      //     >
      //       <IconFont type="icona-styledulichuangkou" />
      //       {t("session.menus.open_new_window")}
      //     </Menu.Item>
      //   )}
      // </Menu>
    );
  };

  if (!session) {
    return null;
  }

  if (withoutContextMenu) {
    return memoComp;
  }

  const maskShow = () => {
    const mask = document.getElementById("chat-left-mask");
    if (!mask) return;
    mask.style.display = "block";
  };
  const maskHide = () => {
    const mask = document.getElementById("chat-left-mask");
    if (!mask) return;
    mask.style.display = "none";
  };
  const visibleChange = (visible: Boolean) => {
    if (visible) {
      maskShow();
      analysisLog("Xtbg_Msg_Home", "InfoMore");
    } else {
      maskHide();
    }
  };


  const startPos = { x: 0, y: 0 };


  return memoComp ? (
    <Dropdown
      // overlayClassName="sessionContextMenu"
      overlay={renderContextMenu}
      trigger={["contextMenu"]}
      onVisibleChange={visibleChange}
    >
      {memoComp}
    </Dropdown>
  ) : (
    <div />
  );
}

function mapStateToProps({ chat, user }: any) {
  const {
    selectedSession,
    currentEmployee,
    sessionStatusMap,
    administrator,
    ordinary,
    aiNoticeSessionList,
    allSessionList,
    sessionMessageMap,
    customAppList
  } = chat as ChatState;
  return {
    readMsgCustom: user.readMsgCustom,
    topUpModeCustom: user.topUpModeCustom,
    selectedSession,
    currentEmployee,
    sessionStatusMap,
    administrator,
    ordinary,
    aiNoticeSessionList,
    allSessionList,
    sessionMessageMap,
    customAppList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async changeGroupAdmin(data: {
      ordinary: Partial<GroupRoster>[];
      administrator: Partial<GroupRoster>[];
    }) {
      await dispatch({ type: "chat/changeGroupAdmin", payload: data });
    },
    async clearSessionMessage(data: { sessionId: string }) {
      await dispatch({ type: "chat/clearSessionMessage", payload: data });
      focusSDK.sendIpcMessage("flashSessionForceClear", data);
    },
    async updateSelectedSession(data: { selectedSession: SessionProps }) {
      await dispatch({ type: "chat/updateSelectedSession", payload: data });
    },
    launchSingleSession(data: { employee: Employee }) {
      dispatch({ type: "chat/launchSingleSession", payload: data });
    },
    initSelectedSession(data: { selectedSession: any }) {
      dispatch({ type: "chat/initSelectedSession", payload: data });
    },
    launchGroupSession(data: { sid: string }) {
      dispatch({ type: "chat/launchGroupSession", payload: data });
    },
    launchNoticeSession(data: { sid: string }) {
      dispatch({ type: "chat/launchNoticeSession", payload: data });
    },
     launchOrgNoticeSession(data: { sid: string }) {
      dispatch({ type: "chat/launchOrgNoticeSession", payload: data });
    },
    changeSelectMore(data: { selectMore: boolean }) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    },
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    },
    setShowTagList(data: { showTagList: any }) {
      dispatch({ type: "chat/setShowTagList", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Session);
